import type { Dispatch, SetStateAction } from "react"
import Image from "next/image"
import type { CommerceProduct } from "@/app/types"
import { Carousel } from "@/components/organisms/Carousel/carousel"
import { CarouselContent } from "@/components/organisms/Carousel/carousel-content"
import { CarouselItem } from "../Carousel/carousel-item"
import { CarouselNavigation } from "../Carousel/carousel-navigation"
import { CarouselApi } from "@/app/types/carousel"
import { cn } from '@/utils/index'

type CenterSectionProps = {
  images: string[]
  setApi: Dispatch<SetStateAction<CarouselApi>>
  className?: string
}

export const ProductImageList = ({ className, images, setApi }: CenterSectionProps) => {
  const hasOnlyOneImage = images.length <= 1
  return (
    <div className={cn("flex flex-col", className)}>
      <div className="md:sticky md:top-[100px]">
        <Carousel setApi={setApi}>
          <CarouselContent>
            {images.map((image, index) => (
              <CarouselItem className="relative aspect-square" key={image}>
                <Image
                  alt={"Product Image"}
                  src={image}
                  fill
                  className="object-cover"
                  priority={index === 0}
                  sizes="(max-width: 450px) 300px, 480px"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          {!hasOnlyOneImage && (
            <div className="mt-4 flex justify-center gap-10 pb-6">
              <CarouselNavigation direction="prev" className="relative" />
              <CarouselNavigation direction="next" className="relative" />
            </div>
          )}
        </Carousel>
      </div>
    </div>
  )
}
